import { h, Host } from "@stencil/core";
export class OffcanvasPrev {
    onClick(event) {
        event.preventDefault();
        const parent = this.el.parentElement;
        parent.parentElement.classList.remove('offcanvas-child-active');
        parent.classList.remove('offcanvas-item-active');
    }
    render() {
        return h(Host, { key: 'd7da9acb87356fc0d55ae273ce31fb740d85acd9', role: "button", class: {
                'offcanvas-back': true
            } }, h("slot", { key: 'bd2c298fb3af39d666a4abdc15b9135cad698c61' }));
    }
    static get is() { return "uvex-offcanvas-prev"; }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "onClick",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=offcanvas-prev.js.map
